import(/* webpackMode: "eager" */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/public/static/icons/clock.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/public/static/icons/message.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/public/static/icons/people.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/public/static/icons/pin.svg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/public/static/icons/star.svg");
;
import(/* webpackMode: "eager", webpackExports: ["Lightbox"] */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/src/components/lightbox/Lightbox.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/src/components/map/MyMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Rating"] */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/src/components/rating/Rating.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/src/components/reservation/TourReservation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reviews"] */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/src/components/reviews/Reviews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimalsToSee"] */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/src/components/tour/AnimalsToSee.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/src/components/tour/css/callToAction.css");
;
import(/* webpackMode: "eager", webpackExports: ["TourIncludes"] */ "/codebuild/output/src2627177501/src/faunaexplore-frontend/src/components/tour/TourIncludes.tsx");
